export default __webpack_public_path__ + "img/contact-banner.asset.12797fb3.png";